import React, { Fragment, Component } from 'react';
import '../App.css';
import PropTypes from 'prop-types';


class Modal extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false);
  }

  handleClick(e) {
    return;
  }

  formatText(text){
    // Returns a versoin of the text with overflow set
    return text.slice(0, 810);
  }

  formatTextSmall(text){
    // Returns a versoin of the text with overflow set
    return text.slice(0, 340);
  }

  render() {
    let image_url = this.props.data.winner_image_modal ? this.props.data.winner_image_modal : this.props.data.winner_image_thumbnail;
    return (
      <Fragment>
        <div className="modal_window d-none d-lg-block d-md-block">
          <div className="modal_box row" ref={(node) => { this.node = node; }}>
            <div className="col-md-6 modal-text-overflow">
              <div className="modal_category">
                <h1 className="modal_category">{this.props.data.category}</h1>
                <h3 className="modal_winner">{this.props.data.winner}</h3>
              </div>

              <div className="modal_text">
                <p className="author-credit">{this.props.data.author}</p>
                {this.formatText(this.props.data.full_text)}... <a href={this.props.data.article_url}>[Read More]</a>
              </div>

            </div>

            <div className="col-md-6">
            <p href="#" className="close_button" onClick={this.props.onCloseRequest}>✖</p>
              <img 
                className="modal_img img-responsive"
                src={`${process.env.PUBLIC_URL}${image_url}`}
                alt="hello" />
            <p className="modal_caption">{this.props.data.image_credits}</p>
            </div>
          </div>
        </div>

        <div className="modal_window d-xl-none d-lg-none d-md-none">
          <div className="modal_box row" ref={(node) => { this.node = node; }}>
          <p href="#" className="close_button" onClick={this.props.onCloseRequest}>✖</p>

            <div className="col-md-6 modal-text-overflow">
              <div className="modal_category">
                <h1 className="modal_category">{this.props.data.category}</h1>
                <h3 className="modal_winner">{this.props.data.winner}</h3>
              </div>

              <div className="modal_text modal_text_small">
                <p className="author-credit">{this.props.data.author}</p>
                {this.formatTextSmall(this.props.data.full_text)}... <a href={this.props.data.article_url}>[Read More]</a>
              </div>

            </div>

          </div>
        </div>
    </Fragment>
    );
    // this.el = (
    //   <div className="modal_window">
    //     <div className="modal_box" ref={(node) => { this.node = node; }}>
    //       <p href="#" className="close_button" onClick={this.props.onCloseRequest}>✖</p>

    //       <div className="modal_category">    
    //         <h1 className="modal_category">{this.props.data.category}</h1>
    //       </div>
    //       <h2 className="modal_header">{this.props.data.winner}</h2>
    //       <p className="modal_body">{this.props.data.full_text}</p>
    //       <div className="modal_img_holder">
    //         <img className="modal_img" src={`${process.env.PUBLIC_URL}${this.props.data.winner_image_thumbnail}`} alt="hello" />
    //       </div>
    //     </div>
    //   </div>
    // );
    // return (
    //   ReactDOM.createPortal(this.el, document.getElementById('root'))
    // );
  }
}


Modal.propTypes = {
  onCloseRequest: PropTypes.func.isRequired,
};


export default Modal;